import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";
// Toasts portal to <body>, outside any page's .todai-cinematic scope. Putting
// the scope class on the viewport re-points the shadcn tokens consumed by the
// classNames below, so every toast is brand chrome (graphite + violet) on all
// routes. Transparent bg so the scope class doesn't paint the viewport itself.
import "@/pages/cinematic.css";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group todai-cinematic"
      style={{ background: "transparent" }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
